// extracted by mini-css-extract-plugin
export default {"gamesWrapper":"Games_gamesWrapper__-YjG2","col":"Games_col__pBQx+","textWrap":"Games_textWrap__VJ1om","flipBoxFront":"Games_flipBoxFront__xCLgv"};